import React from 'react';
import img1 from '../images/Faq-image.jpg' 
import './style.css';

const FaqsHeader = () => {
  return (
      <div className="row">
    <div className="imgWrapper">
      <img src= {img1}/>
        <div>
          <h2>
            Frequently asked questions
          </h2>

          <p>
          Get answers to frequently asked questions. We’re always here to help.
          </p>
         
        </div>
      </div>
    </div>
  );
};

export default FaqsHeader;


// WEBPACK FOOTER //
// ./src/views/pages/faqs/faqHeader.js